import { createApi } from '@reduxjs/toolkit/query/react';

import customFetchBase from './refreshToken/customFetchBaseQuery';
import {returnLoggedInUserRole} from "../../Utils/index.js";

const api = createApi({
  reducerPath: 'api',
  baseQuery: customFetchBase,
  keepUnusedDataFor: import.meta.env.VITE_CACHE_RESET_TIME ?? 3000,
  tagTypes: ['auth', 'chargingPoint', 'organization', 'roles', 'users', 'orgRoles'],
  endpoints: () => ({})
});

export default api;
